module.exports = __webpack_public_path__ + "img/ites.5472dcc7.png";